/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowLeftSmall: {
  name: 'arrow_left_small';
  data: string;
} = {
  name: 'arrow_left_small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M9.656 16.468a.75.75 0 1 0 1.06-1.06L8.06 12.75h8.69a.75.75 0 0 0 0-1.5H8.06l2.657-2.657a.75.75 0 0 0-1.06-1.06L5.72 11.47a.75.75 0 0 0 0 1.06l3.936 3.938Z" fill="currentColor"/></svg>`
};
